__turbopack_context__.v({
  "zeroCodonationMessage": "ZeroCodonationMessage-module__DdfsrW__zeroCodonationMessage",
});
